/* eslint-disable no-nested-ternary */
import SuperCollapse from '@/components/sharedComponents/SuperCollapse';
import { CustomTable } from '@/components/Table';
import empty from '@/assets/images/other-images/imgvazio.svg';
import { ReactComponent as LocationPin } from '@/assets/images/svg/locationPinNoFill.svg';
import { colors } from '@/styles/colors';
import React, { Fragment } from 'react';
import { ArrowLeft } from 'react-feather';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import dayjs from 'dayjs';
import UserType from '@/model/UserType';
import { toCurrency } from '@/helpers/masks/toCurrency';
import { Dialog } from '@/components';
import { ActionProps } from '@/components/Dialog';
import EventMainReport from '@/model/EventMainReport';
import EventDetailReport from '@/model/EventDetailReport';
import { getItem } from '@/helpers/common/localStorage';
import { REACT_APP_USER } from '@/utils/config';
import { AuthUser } from '@/model/AuthUser';
import { GeneralSale } from '../../components/GeneralSale';
import { SaleDate } from '../../components/SaleDate';
import { SalePdv } from '../../components/SalePdv';
/*
import { SaleSubPdv } from '../../components/SaleSubPdv';
*/
import { Bleeding } from '../../components/Bleeding';

import { Tracking } from '../../components/Tracking';
/*
import { Terminal } from '../../components/Terminal';
import { Validation } from '../../components/Validation';
*/
import { ReportControllerProps, ShouldShowModal } from '../../types';
import { SaleProduct } from '../../components/SaleProduct';
import { DetailContent } from '../../components/DetailContent';
import { Validation } from '../../components/Validation';
import { VoucherCourtesyScreen } from '../../components/VoucherCourtesy';
import { CancellationsScreen } from '../../components/Cancellations';
import { SalePos } from '../../components/SalePos';
import { EventFractionalReportScreen } from '../../components/EventFractionalReportList';

interface ReportTitle {
  title: string;
}

export interface ReportsContentProps {
  event: EventMainReport;
  shouldShowModal: ShouldShowModal;
  visible: boolean;
  eventChild: EventMainReport[];
  reportController: ReportControllerProps;
  userId: string;
  userType: UserType;
  eventDetail: EventDetailReport | undefined;
  onChildPress: (eventSelected: string, eventName: string) => void;
  onShowModal: () => void;
  generatePDF: () => void;
  onToggle: () => void;
}

export const ReportsContent: React.FC<ReportsContentProps> = ({
  event,
  shouldShowModal,
  visible,
  eventChild,
  userType,
  reportController,
  eventDetail,
  onChildPress,
  onShowModal,
  generatePDF,
  onToggle,
}) => {
  const userTypeRender =
    userType === UserType.PDV
      ? 'Vendas por PDV'
      : userType === UserType.SUB_PDV
      ? 'Vendas por SubPDV'
      : '';

  const [reportContent, setReportContent] = React.useState(userTypeRender);

  const reports = [
    {
      title: 'Vendas gerais ingresso',
    },
    {
      title: 'Vendas por data',
    },
    {
      title: 'Vendas por PDV',
    },
    {
      title: 'Vendas por POS',
    },
    /*
    {
      title: 'Vendas por SubPDV',
    }, */
    {
      title: 'Sangria',
    },
    {
      title: 'Rastreamento',
    },
    {
      title: 'Vendas por Produtos',
    },

    {
      title: 'Validação',
    },
    {
      title: 'Voucher e Cortesias',
    },
    {
      title: 'Cancelamentos',
    },
    { title: 'Pagamentos Camarotes Empresariais' },
  ];

  const reportsArtist = [
    {
      title: 'Vendas gerais ingresso',
    },
    {
      title: 'Vendas por data',
    },
    {
      title: 'Vendas por PDV',
    },
    /*
    {
      title: 'Vendas por SubPDV',
    }, */
    {
      title: 'Rastreamento',
    },
    {
      title: 'Validação',
    },
    {
      title: 'Voucher e Cortesias',
    },
    {
      title: 'Cancelamentos',
    },
  ];

  const reportsPdv = [
    {
      title: 'Vendas por PDV',
    },
    {
      title: 'Vendas por SubPDV',
    },
    {
      title: 'Rastreamento',
    },
    {
      title: 'Pagamentos Camarotes Empresariais',
    },
  ];

  const reportsSubPdv = [
    {
      title: 'Vendas por SubPDV',
    },
  ];

  const renderActionDialogToCancel: ActionProps = {
    title: 'Fechar',
    onClick: (): void => onToggle(),
    theme: 'noneBorder',
  };

  const user = getItem(String(REACT_APP_USER)) as AuthUser;

  const ReportCards = (): JSX.Element => {
    let newReports: ReportTitle[] = [];
    if (user.id !== '81869413-130d-4476-a6e8-9299d89bbb4e') {
      if (userType === UserType.Employee || userType === UserType.CONTRACTOR) {
        newReports = reports;
      } else if (userType === UserType.ARTIST) {
        newReports = reportsArtist;
      } else if (userType === UserType.PDV) {
        newReports = reportsPdv;
      } else if (userType === UserType.SUB_PDV) {
        newReports = reportsSubPdv;
      }
    } else if (user.id === '81869413-130d-4476-a6e8-9299d89bbb4e') {
      newReports = [
        {
          title: 'Vendas gerais ingresso',
        },
      ];
    }

    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
          gap: '14px',
          width: '100%',
        }}
      >
        {newReports.map((report, index) => {
          const isSelected = report.title === reportContent;
          return (
            <div
              key={`Card-Report-${index}`}
              onClick={() => setReportContent(report.title)}
              style={{
                backgroundColor: isSelected ? '#ffffff' : '#f8f9fa',
                color: isSelected ? colors.lightBlue : '#495057',
                border: isSelected ? `2px solid ${colors.lightBlue}` : '1px solid #e9ecef',
                boxShadow: isSelected
                  ? '0 4px 12px rgba(60, 175, 200, 0.15)'
                  : '0 2px 4px rgba(0, 0, 0, 0.03)',
                borderRadius: '12px',
                padding: '16px 14px',
                minHeight: '75px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                fontWeight: isSelected ? 600 : 500,
                fontSize: '13.5px',
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out',
                userSelect: 'none',
              }}
              onMouseEnter={e => {
                if (!isSelected) {
                  e.currentTarget.style.backgroundColor = '#ffffff';
                  e.currentTarget.style.borderColor = '#1b488080';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }
              }}
              onMouseLeave={e => {
                if (!isSelected) {
                  e.currentTarget.style.backgroundColor = '#f8f9fa';
                  e.currentTarget.style.borderColor = '#e9ecef';
                  e.currentTarget.style.transform = 'translateY(0)';
                }
              }}
            >
              {report.title}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <Container className="mainContainer" fluid={true}>
        {/* Header Redesenhado - Limpo, Neutro e sem Emojis */}
        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '12px',
            padding: '20px 24px',
            marginBottom: '24px',
            border: '1px solid #e9ecef',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.03)',
          }}
        >
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <div className="d-flex align-items-center mb-2 mb-md-0">
              <Link
                to={`${process.env.PUBLIC_URL}/dashboard/event`}
                style={{
                  width: '38px',
                  height: '38px',
                  borderRadius: '10px',
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #e9ecef',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  textDecoration: 'none',
                  transition: 'all 0.2s ease',
                }}
              >
                <ArrowLeft color="#495057" size={18} />
              </Link>
              <div>
                <h4
                  style={{
                    margin: 0,
                    fontWeight: 600,
                    color: '#212529',
                    fontSize: '18px',
                    lineHeight: '1.3',
                  }}
                >
                  {event.name}
                </h4>
                <div
                  className="d-flex align-items-center text-muted"
                  style={{ fontSize: '13px', marginTop: '4px', gap: '16px' }}
                >
                  <span>
                    Data: {event.date ? dayjs(event.date).format('DD/MM/YYYY') : 'Sem data'}
                  </span>
                  <span className="d-flex align-items-center">
                    <LocationPin
                      style={{ width: '14px', height: '14px', marginRight: '4px' }}
                      color="#6c757d"
                    />
                    {`${event.city || '---'}/${event.state || '---'}`}
                  </span>
                </div>
              </div>
            </div>

            {event.imageDetailUrl && (
              <div className="d-none d-md-block">
                <img
                  style={{
                    borderRadius: '8px',
                    height: '56px',
                    width: '100px',
                    objectFit: 'cover',
                    border: '1px solid #e9ecef',
                  }}
                  src={event.imageDetailUrl ? event.imageDetailUrl : empty}
                  alt={event.name}
                />
              </div>
            )}
          </div>
        </div>
        {/* Seção Vendas de Ingressos */}
        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '12px',
            padding: '20px 24px',
            marginBottom: '24px',
            border: '1px solid #e9ecef',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.03)',
          }}
        >
          <h6
            style={{
              fontSize: '14px',
              fontWeight: 600,
              color: '#495057',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              marginBottom: '16px',
            }}
          >
            Vendas de Ingressos
          </h6>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
              gap: '12px',
            }}
          >
            {(user.userType === UserType.Employee && event.ticket
              ? [
                  { title: 'Vendas de hoje', content: event.ticket.amountSale || '-----' },
                  { title: 'Cortesias', content: event.ticket.amountCourtesy || '-----' },
                  {
                    title: 'Descontos',
                    content: event.ticket.discount
                      ? `${toCurrency(event.ticket.discount)}`
                      : '-----',
                  },
                  { title: 'Vendas', content: event.ticket.totalSales || '-----' },
                  {
                    title: 'Vendas + Cortesias',
                    content:
                      (event.ticket.totalSales || 0) + (event.ticket.amountCourtesy || 0) ||
                      '-----',
                  },
                  {
                    title: 'Taxas',
                    content: event.ticket.fees ? `${toCurrency(event.ticket.fees)}` : '-----',
                  },
                  {
                    title: 'Faturamento',
                    content: event.ticket.saleValue
                      ? `${toCurrency(event.ticket.saleValue)}`
                      : '-----',
                  },
                  {
                    title: 'Ticket Médio',
                    content: event.ticket.averageTicket
                      ? `${toCurrency(event.ticket.averageTicket)}`
                      : '-----',
                  },
                ]
              : [
                  { title: 'Vendas de hoje', content: event.ticket?.amountSale || '-----' },
                  { title: 'Cortesias', content: event.ticket?.amountCourtesy || '-----' },
                  { title: 'Descontos', content: event.ticket?.discount || '-----' },
                  { title: 'Vendas', content: event.ticket?.totalSales || '-----' },
                  {
                    title: 'Vendas + Cortesias',
                    content:
                      (event.ticket?.totalSales || 0) + (event.ticket?.amountCourtesy || 0) ||
                      '-----',
                  },
                  {
                    title: 'Faturamento',
                    content: event.ticket?.saleValue
                      ? `${toCurrency(event.ticket.saleValue)}`
                      : '-----',
                  },
                  {
                    title: 'Ticket Médio',
                    content: event.ticket?.averageTicket
                      ? `${toCurrency(event.ticket.averageTicket)}`
                      : '-----',
                  },
                ]
            ).map((item, idx) => (
              <div
                key={`ticket-metric-${idx}`}
                style={{
                  backgroundColor: '#f8f9fa',
                  borderRadius: '10px',
                  padding: '12px 14px',
                  border: '1px solid #f1f3f5',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <span
                  style={{
                    fontSize: '11px',
                    fontWeight: 600,
                    color: '#6c757d',
                    textTransform: 'uppercase',
                    marginBottom: '4px',
                  }}
                >
                  {item.title}
                </span>
                <span
                  style={{
                    fontSize: '15px',
                    fontWeight: 600,
                    color: '#343a40',
                  }}
                >
                  {item.content}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Seção Vendas de Produtos */}
        {event.product && event.product.saleValue > 0 && (
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '12px',
              padding: '20px 24px',
              marginBottom: '24px',
              border: '1px solid #e9ecef',
              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.03)',
            }}
          >
            <h6
              style={{
                fontSize: '14px',
                fontWeight: 600,
                color: '#495057',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                marginBottom: '16px',
              }}
            >
              Vendas de Produtos
            </h6>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                gap: '12px',
              }}
            >
              {[
                { title: 'Qtd. Vendas', content: event.product.amountSale || '-----' },
                { title: 'Cortesias', content: event.product.amountCourtesy || '-----' },
                { title: 'Descontos', content: event.product.discount || '-----' },
                {
                  title: 'Vendas',
                  content: event.product.saleValue
                    ? `${toCurrency(Number(event.product.saleValue))}`
                    : '-----',
                },
                {
                  title: 'Comissão',
                  content: toCurrency(event.product.fee) || '-----',
                },
                {
                  title: 'Vendas + Comissão',
                  content: event.product.saleValue
                    ? `${toCurrency(event.product.saleValue + Number(event.product.fee))}`
                    : '-----',
                },
                {
                  title: 'Ticket Médio',
                  content: event.product.averageTicket
                    ? `${toCurrency(event.product.averageTicket)}`
                    : '-----',
                },
              ].map((item, idx) => (
                <div
                  key={`product-metric-${idx}`}
                  style={{
                    backgroundColor: '#f8f9fa',
                    borderRadius: '10px',
                    padding: '12px 14px',
                    border: '1px solid #f1f3f5',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: 600,
                      color: '#6c757d',
                      textTransform: 'uppercase',
                      marginBottom: '4px',
                    }}
                  >
                    {item.title}
                  </span>
                  <span
                    style={{
                      fontSize: '15px',
                      fontWeight: 600,
                      color: '#343a40',
                    }}
                  >
                    {item.content}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Seção Eventos Diários no mesmo padrão de Card neutro */}
        {eventChild && eventChild.length > 0 && (
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '12px',
              padding: '20px 24px',
              marginBottom: '24px',
              border: '1px solid #e9ecef',
              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.03)',
            }}
          >
            <SuperCollapse
              className={eventChild ? ' ' : 'collapse-disabled collapse-disable-text'}
              title="Eventos Diários"
              content={
                <CustomTable
                  numberRowsPerPage={0}
                  progressPending={false}
                  theme="secondaryWithoutBorder"
                  columns={[
                    {
                      name: '',
                      selector: row => row.image,
                      width: '100px',
                    },
                    {
                      name: 'Nome do evento',
                      selector: row => row.name,
                    },
                    {
                      name: 'Venda',
                      selector: row => row.venda,
                    },
                    {
                      name: 'Cortesia',
                      selector: row => row.cortesia,
                    },
                    {
                      name: 'Total de vendas',
                      selector: row => row.totalVendas,
                    },
                    {
                      name: 'Faturamento',
                      selector: row => row.arrecadacao,
                    },
                    {
                      name: 'Ticket médio',
                      selector: row => row.ticketMedio,
                    },
                  ]}
                  data={
                    eventChild.map &&
                    eventChild.map(child => ({
                      image: (
                        <div
                          onClick={() => onChildPress(child.id, child.name)}
                          style={{ cursor: 'pointer' }}
                        >
                          <img
                            style={{
                              borderRadius: '6px',
                              objectFit: 'cover',
                              height: '40px',
                              width: '70px',
                              border: '1px solid #e9ecef',
                            }}
                            src={child.imageUrl ? child.imageUrl : empty}
                            alt={child.name}
                          />
                        </div>
                      ),
                      name: (
                        <div
                          onClick={() => onChildPress(child.id, child.name)}
                          style={{ cursor: 'pointer', fontWeight: 600, color: '#212529' }}
                        >
                          {child.name || '---'}
                        </div>
                      ),
                      venda: (
                        <div
                          onClick={() => onChildPress(child.id, child.name)}
                          style={{ cursor: 'pointer' }}
                        >
                          {child.ticket?.totalSales !== undefined &&
                          child.product?.amountSale !== undefined
                            ? child.ticket.totalSales + child.product.amountSale
                            : '---'}
                        </div>
                      ),
                      cortesia: (
                        <div
                          onClick={() => onChildPress(child.id, child.name)}
                          style={{ cursor: 'pointer' }}
                        >
                          {child.ticket?.amountCourtesy !== undefined &&
                          child.product?.amountCourtesy !== undefined
                            ? child.ticket.amountCourtesy + child.product.amountCourtesy
                            : '---'}
                        </div>
                      ),
                      totalVendas: (
                        <div
                          onClick={() => onChildPress(child.id, child.name)}
                          style={{ cursor: 'pointer' }}
                        >
                          {child.ticket?.totalSales !== undefined &&
                          child.product?.amountSale !== undefined
                            ? child.ticket.totalSales +
                              child.product.amountSale +
                              child.ticket.amountCourtesy +
                              child.product.amountCourtesy
                            : '---'}
                        </div>
                      ),
                      arrecadacao: (
                        <div
                          onClick={() => onChildPress(child.id, child.name)}
                          style={{ cursor: 'pointer', fontWeight: 600, color: colors.lightBlue }}
                        >
                          {child.ticket?.totalSales !== undefined &&
                          child.product?.saleValue !== undefined
                            ? toCurrency(child.ticket.saleValue + child.product.saleValue)
                            : '---'}
                        </div>
                      ),
                      ticketMedio: (
                        <div
                          onClick={() => onChildPress(child.id, child.name)}
                          style={{ cursor: 'pointer' }}
                        >
                          {child.ticket?.averageTicket || child.product?.averageTicket
                            ? toCurrency(
                                (child.ticket.averageTicket || 0) +
                                  (child.product.averageTicket || 0),
                              )
                            : '---'}
                        </div>
                      ),
                    }))
                  }
                />
              }
            />
          </div>
        )}
        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '12px',
            padding: '20px 24px',
            marginBottom: '24px',
            border: '1px solid #e9ecef',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.03)',
          }}
          className="no-print"
        >
          <h6
            style={{
              fontSize: '14px',
              fontWeight: 600,
              color: '#495057',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              marginBottom: '16px',
            }}
          >
            Selecione o tipo de relatório
          </h6>
          <ReportCards />
        </div>

        {reportContent === 'Vendas gerais ingresso' && (
          <GeneralSale
            userId={user.id}
            payments={event.ticket.payment}
            reportController={reportController}
            generatePDF={generatePDF}
            onShowModal={onShowModal}
          />
        )}
        {reportContent === 'Vendas por data' && (
          <SaleDate reportController={reportController} generatePDF={generatePDF} />
        )}
        {reportContent === 'Vendas por PDV' && (
          <SalePdv generatePDF={generatePDF} reportController={reportController} />
        )}
        {reportContent === 'Vendas por POS' && (
          <SalePos reportController={reportController} generatePDF={generatePDF} />
        )}
        {/* reportContent === 'Vendas por SubPDV' && (
          <SaleSubPdv generatePDF={generatePDF} reportController={reportController} />
        ) */}
        {reportContent === 'Sangria' && (
          <Bleeding generatePDF={generatePDF} reportController={reportController} />
        )}
        {reportContent === 'Rastreamento' && (
          <Tracking generatePDF={generatePDF} reportController={reportController} />
        )}
        {reportContent === 'Pagamentos Camarotes Empresariais' && (
          <EventFractionalReportScreen eventId={reportController.eventId} />
        )}

        {reportContent === 'Vendas por Produtos' && (
          <SaleProduct
            product={event.product}
            generatePDF={generatePDF}
            reportController={reportController}
          />
        )}

        {reportContent === 'Validação' && (
          <Validation generatePDF={generatePDF} reportController={reportController} />
        )}

        {reportContent === 'Voucher e Cortesias' && (
          <VoucherCourtesyScreen reportController={reportController} />
        )}

        {reportContent === 'Cancelamentos' && (
          <CancellationsScreen reportController={reportController} />
        )}
      </Container>
      <Dialog
        title="Vendas por tipo de pagamento"
        visible={visible}
        onClose={onToggle}
        position={'center'}
        isContentWithCard={true}
        actions={[
          {
            [ShouldShowModal.detail]: renderActionDialogToCancel,
          }[shouldShowModal],
        ]}
      >
        {
          {
            [ShouldShowModal.detail]: <DetailContent eventDetail={eventDetail} />,
          }[shouldShowModal]
        }
      </Dialog>
      {/* <ReportFooter data={footerData} hasFooter={hasFooter} /> */}
    </>
  );
};
